module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/ultilities/user/user.component.css
// module id = ./src/app/ultilities/user/user.component.css
// module chunks = main